import React, { useState } from "react";

import { FormButton } from "components";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { FormikSelectInput } from "components/UI/Inputs/FormikInputs";
import { hotelUpd } from "services/services-mia";

const ESTADOS_HOTEL = [
    { id: "A", label: "Activo" },
    { id: "B", label: "Baja" },
    { id: "S", label: "Suspendido" }
];

export default function UpdateStateModal({ updateList, hotel, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const validationSchema = yup.object({
        estado: yup.string().required("Debe seleccionar un estado"),
    });

    const handleSubmit = async (values) => {
        setInRequest(true);
        const response = await hotelUpd({
            SFHotelId: hotel?.SFHotelId,
            SFHotelNombre: hotel?.SFHotelNombre,
            SFHotelDomicilioCalle: hotel?.SFHotelDomicilioCalle,
            SFHotelDomicilioCasa: hotel?.SFHotelDomicilioCasa,
            SFHotelDomicilioCPA: hotel?.SFHotelDomicilioCPA,
            SFHotelEmail: hotel?.SFHotelEmail,
            SFHotelTelefono: hotel?.SFHotelTelefono,
            localidadId: hotel?.localidadId,
            SFHotelLatitud: hotel?.SFHotelLatitud,
            SFHotelLongitud: hotel?.SFHotelLongitud,
            SFHotelCUIT: hotel?.SFHotelCUIT,
            SFHotelCheckin: hotel?.SFHotelCheckin,
            SFHotelCheckout: hotel?.SFHotelCheckout,
            SFHotelVersion: hotel?.SFHotelVersion,
            SFHotelStatus: values.estado,
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            `Se cambió el estado del hotel ${hotel.SFHotelNombre} exitosamente`,
            functions
        );

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                estado: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            {({ values }) => (
                <Form className={styles.inputs} noValidate>
                    <div className={styles["column-sm"]} style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "stretch", gap: "20px" }}>

                        <div style={{ borderBottom: "1px solid #eee", paddingBottom: "10px" }}>
                            <h2 style={{ textAlign: "left", margin: 0 }}>
                                <strong>{hotel.SFHotelNombre}</strong>
                                {hotel.SFHotelStatus === "A" ? (
                                    <span style={{ marginLeft: "10px", padding: "4px 8px", fontSize: "14px", fontWeight: "600", color: "#2e7d32", backgroundColor: "#e8f5e9", borderRadius: "4px", verticalAlign: "middle" }}>Activo</span>
                                ) : (
                                    <span style={{ marginLeft: "10px", padding: "4px 8px", fontSize: "14px", fontWeight: "600", color: "#ed6c02", backgroundColor: "#fff3e0", borderRadius: "4px", verticalAlign: "middle" }}>Suspendido</span>
                                )}
                            </h2>
                        </div>

                        <FormikSelectInput
                            name="estado"
                            labelText="Nuevo Estado"
                        >
                            <option value="" disabled>Seleccione el nuevo estado</option>
                            {ESTADOS_HOTEL.map((e) => {
                                if (e.id === hotel.SFHotelStatus) return null;
                                return (
                                    <option
                                        key={e.id}
                                        value={e.id}
                                    >
                                        {e.label}
                                    </option>
                                )
                            })}
                        </FormikSelectInput>

                        <FormButton
                            inRequest={inRequest}
                            disabled={!values.estado}
                            newFormData={{ button: "Confirmar Cambio" }}
                            onCloseModal={closeModal}
                        />

                    </div>
                </Form>
            )}
        </Formik>
    );
}